export default __webpack_public_path__ + "static/media/botoes_laterais_01.534d979d.mp3";